export const xdata = {
  Nav_gsjs:'公司介绍',
  Nav_cpfw:'产品和服务',
  Nav_gwal:'过往案例',
  Nav_idcsjzx:'IDC数据中心服务',
  Nav_qqwltx:'全球网络通信运营服务',
  Nav_xtjc:'系统集成服务',
  Nav_itwb:'IT外包服务',
  Nav_qqsd:'全球SD-WAN服务',
  Nav_qtfw:'其他服务',
  Nav_sdzwt:'SD-WAN组网',
  Nav_sdzw:'全球信息通信技术平台',
  Nav_idct:'IDC组网',
  Nav_idc:'欧洲某动力电池企业IDC组网',
  Nav_zxzw:'国际车企门店跨国混合专线组网',
  Nav_lxwm:'联系我们',
  Nav_qqxxtxjspt:'全球信息通信技术平台',
  Nav_vpnjjfa:'VPN解决方案',

  Nav_lang_zh:'中文',
  Nav_lang_en:'英文',
  Nav_lang_fr:'法语',
  Nav_lang_xy:'匈牙利',
  Nav_lang_de:'德语',

  Foot_bei:'沪ICP备2020033223号-1',
  Foot_phone:'致电我们',

  About_bt:'立即联系我们，了解我们的解决方案如何改变您的业务',
  About_xyl:'匈牙利总部(布达佩斯)',
  About_sh:'上海分公司',
  About_shd:'中国上海浦东新区浦东大道2123号1605',
  About_hk:'香港分公司',
  About_us:'美国办公室',
  About_de:'德国分公司',
  About_sp:'西班牙分公司',

  Home_des:'用科技与服务为跨国通信架设桥梁，给文化出海插上翅膀',
  Home_icon_t1:'Global Global是一家专业网络建设资质的技术公司。我们专注于提供高度稳定、安全、可靠的互联网建设、技术服务和电信增值服务。',
  Home_icon_t2:'我们致力于计算机系统的咨询、设计、施工和技术服务，特别是电信增值服务、企业电信和网络安全系统。企业可以在宽带密集型应用如VOIP、无线领域广泛采用新技术。',
  Home_icon_t3:'我们拥有多年的互联网运营和企业通信系统经验。我们的运营团队由经验丰富、专业的PMP、CISA、CISSP、CCNP、MCSE等认证持有者组成。',
  Home_icon_t4:'在全球范围内，已建成全球骨干数据网络、骨干POP节点、数据中心，并在此基础上搭建了多个服务平台，能为国内外企业提供覆盖全球和多样化的信息网络服务，包括国际专线、卫星通信、互联网快速接入、SD-WAN组网、海外园区宽  带接入、海外中文数字电视、企业语音电话、车联网及海外ICT集成、运维服务等。',
  Home_zzjg:'组织结构',
  Home_gl:'管理',
  Home_glm:'高级合格管理团队',
  Home_xzzx:'行政中心',
  Home_xzzxm:'高效、合格的行政团队',
  Home_yxzx:'营销中心',
  Home_yxzxm:'专业销售团队',
  Home_kfzx:'客户服务中心',
  Home_kfzxm:'专业客户服务团队',
  Home_jszc:'技术支持中心',
  Home_jszcm:'专业的 & 合格的技术支持团队',
  Home_zyfw:'专业及服务能力',
  Home_zyfwm:'描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述描述',
  Home_xs:'小时',
  Home_zxkf:'在线客服随时响应',
  Home_xcwh:'现场维护',
  Home_qgfw:'全球范围派遣直达',
  Home_ycwh:'远程维护',
  Home_wljk:'网络监控远程技术支持',
  Home_rccb:'人才储备',

  Home_glgb:'管理干部经验丰富',
  Home_glgbt1:'由来自全球知名通信公司全球网络规划和IT运维部部长担任技术总监',
  Home_glgbt2:'由来自全球知名通信公司全球网络运营中心资深专家担任网络架构师',
  Home_glgbt3:'由来自全球知名通信公司网络国际市场',
  Home_ygjs:'员工技术能力过硬',
  Home_ygjst1:'硕士以上学历30%，本科以上学100%',
  Home_ygjst2:'CCIE、CCNP/NA、HCIE（RS、DCSecurity）、HCIP、HCNP、H3CIE、H3CSE',
  Home_ygjst3:'ACA/ACP、iDirect认证',
  Home_ygjst4:'PMP、Oracle OCP',
  Home_yghw:'员工海外经验丰富',
  Home_yghwt1:'平均拥有3～5年的海外工作经验',
  Home_yghwt2:'电信领域多年从业经验，深入理解企业业务和服务需求',
  Home_yghwt3:'充分胜任企业的海外服务工作',
  Home_hzhb:"战略合作伙伴",
  Home_wmdkh:'我们的客户',

  Int_tms:'来自全球的ICT解决方案为客户提供固定电话、个人手持电话系统（PHS）、企业语音系统、公用电话等电话服务。我们可以提供拨打本地电话、国内国际长途、国际（包括港澳台）、4006呼叫中心、IP电话、电话卡等语音通信服务',
  Int_yjjc:'硬件集成',
  Int_yjjct:'服务器、存储设备、网络设备等硬件设备的整合和配置，确保硬件环境的稳定性和高效性。',
  Int_rjjc:'软件集成',
  Int_rjjct:'操作系统、数据库、中间件、应用软件等各个层面的软件的安装和配置，确保软件之间的兼容性和优化软件性能。',
  Int_wljc:'网络集成',
  Int_wljct:'网络设备、网络协议、网络安全的整合，构建稳定、高效的网络环境，并考虑网络的扩展性和可维护性。',
  Int_sjjc:'数据集成',
  Int_sjjct:'数据的整合、迁移、同步等，确保数据的完整性、一致性和可用性，同时考虑数据的安全性和隐私保护。',
  Int_aqjc:'安全集成',
  Int_aqjct:'满足信息系统安全技术要求和安全管理要求，包括物理安全、网络安全、应用安全等。',
  Int_gljc:'管理和业务流程集成',
  Int_gljct:'对管理和业务流程的整合，以提高工作效率和服务质量。',

  Int_ywfw:'Global Global 的ICT运维服务提供(业务类)',
  Int_ywfwt1:'基础网络运维：局域网、广域网、电话网、监控网络等',
  Int_ywfwt2:'桌面运维：办公电脑、主机操作系统安装和故障处理、办公软件维护、打印机安装和维护等',
  Int_ywfwt3:'工程服务：综合布线、监控系统部署、通讯塔建设等',
  Int_ywfwt4:'报告文档、业务培训：定期提供运维、支持报告，并为相应的用户团队提供专业的技术培训',

  Int_ywfl:'Global Global 的ICT运维服务提供(类型分类)',
  Int_ywflt1:'报告类服务：日常运维报告、重大事件服务报告、巡检报告、维修报告、故障分析报告、网络优化报告、运维月报年报、技术支持方案等',
  Int_ywflt2:'主动式服务：按次定期巡检服务、按月系统运行检查及分析、网络网管定期巡查等',
  Int_ywflt3:'响应式服务：远程技术支持（电话咨询、电话支持、远程技术支持等等）现场技术支持（现场故障处理、现场技术支持、版本管理补丁管理、现场培训等等）',

  Int_icont1:'全球互联网快速接入业务',
  Int_icont2:'跨境应用访问加速',
  Int_icont3:'SD-WAN多分支组网服务',
  Int_icont4:'虚拟网络海外实验室',
  Int_icont5:'海外园区宽带接入',

  Its_ts:'随着企业规模的不断扩大，IT设备的管理也越来越复杂，意味着维护费用和工作量的增加。专业的IT外包解决方案是根据业务IT环境和需求定制的，不仅可以完成日常的日常维护服务，“消防”即故障检测和解决，但也可以分析和解决IT操作问题，提高应用程序性能和问题预防',
  Its_tgyw:'提高业务关注度',
  Its_tgywt1:'外包允许公司将注意力集中于更广阔的业务问题，同时掌握外部专家所提供的运作细节。对很多公司，外包的关键原因仅仅是，有一些“如何来做的（how to do）”的问题耗费了管理层大量的资源和精力，一旦将这些问题外包给外部专家，管理的效率和成本都大大改善。',
  Its_hdcs:'获得世界级的出色能力',
  Its_hdcst1:'通过专业化的特性，外包供应商导入扩展的资源来满足客户的需求。组织与这样的供应商合作，就获得了这些先进的技术、工具和能力的使用效益；企业甚至可以获得更多结构化的方法、流程和文档，和最重要的竞争优势。',
  Its_jscz:'加速重组的收益',
  Its_jsczt1:'外包通常是更强大的管理工具——BPR——的一项副产品。在与外部企业合作的过程中，外包使企业可以快速认识到流程重组的预期收益。',
  Its_fdfx:'分担风险',
  Its_fdfxt1:'与企业在IT方面投资相关联的有无数的风险。当公司采取外包时，就自然会更灵活、更动态并且更好的使自己改变以满足外部变动机会的需要。',
  Its_znxhd:'将IS资源转向战略性活动',
  Its_znxhdt1:'很多组织面临可用资源限制问题。外包允许资源从非核心能力向提供更大回报的核心活动转移。',

  Its_ms1:'为了确保高质量的服务，制定的管理办法和服务流程充分考虑客户的特点和习惯，及用户的实际需求，以满足用户需求为目标，方便用户使用为基本原则。项目 (合同) 在正式签约时设专职项目经理，成立项目组，根据项目的技术特点，项目组下设各专业子项目组。项目组成员职责明确。项目完成交付后，设专职客服经理，可提供客户要求的对运维服务、账务服务、报表服务等一系列专业及个性化服务要求。',
  Its_ms2:'IT运维的服务内容 (主动运维+远程处理+区域运维)',

  Ope_hlw:'互联网和数据接入业务',
  Ope_hlwt1:'为客户提供网络服务。利用高质量的宽带资源,为客户提供各种网络访问选项，包括MPLS-VPN、IPLC, DIA，ADSL等,更可以提供BGP多线接入都为客户提供高速稳定的互联网接入。',
  Ope_sbzy:'设备租用、代购',
  Ope_sbzyt1:'与主流设备供应商合作为客户提供一站式解决方案。',
  Ope_yfw:'云服务',
  Ope_yfwt1:'多云接入，云网融合；自动化部署及运维，提高保障效率，降低人力投入；SASE安全防护，保护用户信息资产。',
  Ope_fwtg:'服务提供',
  Ope_fwtgt1:'借助拥有丰富项目经验的工程团队，以及广泛的产品、物流、清关、许可、运维渠道和经验， Global在全球范围内为客户开展网络和通讯集成建设“ Turnkey”交钥匙服务， 免除用户在采购、物流、运输、安装调试和运维方面的烦恼， 让客户更加专注于核心业务的开展',
  Ope_fwtgt2:'外部网络接入、有线电话、视频监控、无线通讯、内部网络覆盖',
  Ope_fwtgt3:'车辆跟踪、数据中心、应急广播、安防系统、网络安全、有线电视',
  Ope_qqhz:'全球合作通信运营商',
  Ope_qqhzt1:'AT&T 、法国电信、德国电信、ORANGE、中国移动、中国联通、中国电信等',
 
 
  Dat_fwqzy:'服务器租用',
  Dat_fwqzyt1:'价格计算 | 灵活配置',
  Dat_sjzx:'数据中心服务',
  Dat_sjzxt1:'全球部署 | 满足需求',
  Dat_cloud:'CloudLink',
  Dat_cloudt1:'云网融合 | 多云互联',
  Dat_qqdk:'全球带宽',
  Dat_qqdkt1:'低延迟率 丨 国际直连',

  Dat_glpt:'HPC管理平台',
  Dat_jkfx:'监控分析系统',
  Dat_yglpt:'云管理平台',
  Dat_xtsj:'信天数据中心',
  Dat_xtsjt1:'基于多元融合平台的信天数据中心，可提供包括信天数据中心托管服务，私有云，公有云，异地灾备，以及全冗余设计数据托管解决方案及一站式的云迁移和管理服务，解放IT运维人员，让客户更安心。',
  Dat_xtsjt2:'机柜区域：机柜之间距离1.3米，支持VIP空间改造隔离',
  Dat_xtsjt3:'加固地板：1000公斤/m²',
  Dat_xtsjt4:'架空地板：800公斤/m²',
  Dat_xtsjt5:'天花板到架空地板距离：400cm',
  Dat_xtsjt6:'架空板高度：50cm',
  Dat_xtsjt7:'机房布线：两路电力线路，预放六类网线，强电线缆与弱电线缆分开部署',

  Dat_shhl:'上海呼兰数据中心',
  Dat_shhlt1:'上海市呼兰数据中心位于宝山区呼兰路523号，交通便利，配备双市电和UPS，提供99.99%的供电可用性保障。 提供7*24小时服务支持，工程师驻场，实时网络监控。它为现场工程师和实时网络监控提供全天候服务支持。',
  Dat_shhlt2:'建筑结构可承受8级地震、台风或雷电',
  Dat_shhlt3:'总建筑面积：5000平方米',
  Dat_shhlt4:'接待面积：1800平方米',
  Dat_shhlt5:'地板支撑最大重量：750Kg',
  Dat_shhlt6:'天花板高度：4.5米',
  Dat_shhlt7:'活动地板高度：50 CM',

  Dat_shdx:'上海电信南汇IDC',
  Dat_shdxt1:'南汇IDC位于上海杨高路5788号南汇信息产业园，是亚太核心电信枢纽之一，占地面积约155.71公顷。连接吞吐量达40Gbps，直连ChineNet骨干网，成为上海地区领先者。 数据中心网络构建全弹性无单点故障、千兆以太网，克服带宽瓶颈。 数据中心配备200V UPS，保证IDC机房不间断供电，并内置冗余大功率馈电智能UPS。 2+2备份和四路通信电源，电池充足，可供所有IDC设备运行2小时。',
  Dat_shdxt2:'IDC 的建筑抗震等级为 8 级',
  Dat_shdxt3:'地板承重为 1,000Kg/m2',

  Dat_shlt:'上海联通周浦IDC',
  Dat_shltt1:'云东华混合云架构核心节点、可定制的VIP区、高电气柜提供了更灵活的环境资源利用，也是城市灾备机房的首选。',
  Dat_shltt2:'总建筑面积：21427平方米',
  Dat_shltt3:'托管面积：4958平方米',
  Dat_shltt4:'最大地板荷载：810 kg',
  Dat_shltt5:'网络接入',
  Dat_shltt6:'350Gbps接入联通运营商城域骨干网。',
  Dat_shltt7:'20Gbps BGP对接电信、中国联通、移动骨干网',
  Dat_shltt8:'独立数据中心建设，抵御8级地震、强抗风暴、雷电',
  
  Dat_dlsd:'达拉斯都会区数据中心网络',
  Dat_dlsdt1:'达拉斯地区的Equinix拥有八个国际商务交换™（IBX®）数据中心，总共拥有超过311,000平方英尺（28,925平方米）的机房空间，并提供未来扩展的额外空间。DA1、DA2、DA3和DA6位于Infomart数据中心®内，后者是美国第五大互联数据中心。DA4位于Univision Tower，是西南地区通信服务提供商的主要枢纽。DA7位于普莱诺，靠近Infomart数据中心，可提供连接到Equinix Fabric的服务。位于欧文的DA9适合具有大型部署需求的客户，可满足数据增长的需求。DA11位于Infomart大厦旁边，是美国中部地区第一个灵活数据中心。这些设施靠近达拉斯地区的银行、商业、电信、计算技术、能源、医疗研究、运输和物流公司。',
  Dat_obs:'OBS诺曼底数据中心',
  Dat_obst1:'18公顷土地，初始运营建筑面积为5,000 平方米，内部设有 4 个技术房间，每个房间拥有双电源电路、完全独立和冗余电源、独立冷却水电路以及高密度区域。',
  Dat_obst2:'可独立建设三座额外建筑，支持高达 10 兆瓦（MW）的 IT 负载',
  Dat_obst3:'架构满足 "TIER IV" 标准，以保证超过 99.995% 的可用性',
  Dat_obst4:'提供多重网络和能源冗余以确保最大安全性',
  Dat_obst5:'数据中心支持高密度服务器架，每个机架的功率范围为 5 千瓦（KW）到 20 千瓦（KW）',
  Dat_obst6:'每台备用电源发电机具备 72 小时的自主运行能力，以备电力中断',
  Dat_obst7:'提供全年 24/7/365 服务',
  Dat_obst8:'Normandy 数据中心已获得 ISAE 3402 和 ISO 14001 认证，同时满足ISO 27001PCI DSS 要求',
  Dat_obst9:'用于托管 "健康解决方案" 和安全云系统',

  Dat_ystbe:'伊斯坦布尔数据中心',
  Dat_ystbet1:'伊斯坦布尔位于欧洲和亚洲的交汇点，是土耳其的商业首都，也是建立世界级数据中心的理想位置。Equinix是土耳其唯一的主要国际零售数据中心提供商，而我们的国际商务交换™（IBX®）数据中心是连接最为密集的数据中心之一。我们为伊斯坦布尔的客户提供多种高级互连选项，融入一个多样化且快速增长的数字生态系统。我们的数据中心靠近主要商业区域，为客户提供无与伦比的弹性和连接性，覆盖东南欧洲、非洲、中东和亚洲。此外，我们拥有大量的机房空间，总面积超过21,000平方英尺（2,000平方米）。其他优势包括可扩展的技术空间和全面冗余的电源供应，以确保运营的弹性和先进的安全性。',

  Dat_hk:'香港SonderCloud数据中心',
  Dat_hkt1:'香港电讯机房的优势',
  Dat_hkt2:'可靠性:提供99.99%的设施运行时间服务水平协议（SLA）。具备国际认证的设施管理和全天候的技术支持',
  Dat_hkt3:'环保意识:中国电信已制定“绿色”数据中心政策，侧重于能源消耗，并采用虚拟化和云计算技术来实现能源节约',
  Dat_hkt4:'安全性:采用最先进的安全措施，包括全天候闭路电视监控和生物识别安全系统。',
  Dat_hkt5:'冗余性:UPS、发电机、电力分配、冷却、安全性以及网络韧性系统均采用N+1冗余配置，以提供额外的备份和保障',
  
  Vpn_xgjj:'Global Global 是一家专业网络建设资质的技术公司；主要包括针对宽带互联网、移动网互联网、企业网和行业专网等不同标准不同规模的网络，提供基础架构产品涵盖网络可视化应用系统的基础设备，特别是在电信增值服务、企业电信和网络安全方面广泛使用全新技术',
  Vpn_xgjjt1:'我们可以为您做些什么？',
  Vpn_xgjjt2:'互联网接入互联网全球信息通信技术解决方案连接客户网络并提供网络服务。利用高质量的宽带资源,为客户提供各种网络访问选项，包括MPLS-VPN、DDN、IPLC、DPLC、MSTP、SDH、DIA；ADSL等,更可以提供BGP多线接入都为客户提供高速稳定的互联网接入。更有4G互联网平台解决方案',
  Vpn_xgjjt3:'VPN 是什么？',
  Vpn_xgjjt4:'VPN 代表“虚拟专用网络”，这是一项保护您的互联网连接和在线隐私的服务。通过加密您的连接，VPN 可以将您的 IP 和在线活动隐藏起来，不被窥视，并保护您的数据免受网络犯罪分子的威胁。',
  Vpn_xgjjt5:'为何选择VPN？',
  Vpn_xgjjt6:'在线保护自己：多亏了各种别致的尖端技术，GlobalVPN使您的设备免受恶意软件的攻击，并保护浏览免受陌生人的监视。有多安全？世界上最强大的计算机也要花上数十亿年的时间才能解密您的数据一一就是如此安全。',
  Vpn_xgjjt7:'适用于您的所有设备',
  Vpn_xgjjt8:'恶意软件防护',
  Vpn_xgjjt9:'远程文件访问',
  Vpn_xgjjt10:'更安全、更好、更轻松的数字生活，威胁防护将在恶意软件下载前予以阻止。',
  Vpn_xgjjt11:'连接到所有设备都只需点击一下。无论您去哪里，都可以使用网状网络安全地连接到设备。',
  Vpn_xgjjt12:'使用GlobalVPN，时刻保持安全',
  Vpn_xgjjt13:'在线安全性',
  Vpn_xgjjt14:' VPN 意为虚拟专用网络，是享受网络安全和隐私的理想方式之一。它的重要性堪比电脑和移动设备的防病毒软件。安全的 VPN 通过强大的在线加密来掩护您的数据，避免您的互联网活动被他人窥探。但与许多在线隐私工具一样，您是否拥有真正安全的 VPN，取决于所使用的服务。一些免费或廉价 VPN 服务在基础设施和用户隐私上“偷工减料”，唯利是图。因此，选对 VPN 和使用 VPN，同等重要。VPN通过加密互联网流量和隐藏真实 IP 地址来保护您的在线生活。从连接到 VPN 服务器的那一刻起，您发送和接收的所有数据都将被隐藏起来，不让互联网服务提供商（ISP）、政府机构以及其他第三方看到。您还将获得一个新的 IP，该 IP 将隐藏您的虚拟位置，让您的在线活动很难被追踪到。这意味着无论如何您的身份都将受到保护，您的私人数据也将保持私密。',
  Vpn_xgjjt15:'隐藏您的IP地址',
  Vpn_xgjjt16:'所有连接到互联网的设备（无论是您的智能手机，还是打印机）都会获得一个 IP 地址，用来与网站和其他设备进行通信。同时，您的 IP 地址也可被他人利用，以跟踪您的活动以及透露您的位置，因此，隐藏自己的数字身份是保持您在线隐私和安全的绝佳方式。使用 VPN（虚拟专用网络）掩盖您的 IP 地址，是保护在线隐私极为安全、快速的方式，隐藏您的 IP 地址，保护您的在线活动免受窥视，使您的 ISP（互联网服务提供商）无法跟踪您的浏览历史。',

  Sdw_zyit:'Global平台SD-WAN基础设施',
  Sdw_zyitt1:'VCO：Global的虚拟化集中控制平台，可实现SDWAN统一监控和配置部署;',
  Sdw_zyitt2:'VCG：提供控制平面数据中转，和数据中心、公有云接入服务，可横向扩展，具备高可用性;',
  Sdw_zyitt3:'VCE：零接触部署，可提供智能组网及基于应用识别的链路汇聚和传输优化功能;',
  Sdw_zyitt4:'Global平台SD-WAN基础架构融合',
  Sdw_zyitt5:'中国节点分布',
  Sdw_zyitt6:'以深圳、广州、东莞、武汉 、重庆、上海、杭州、苏州、南京、北京为十大核心SD-WAN收敛节点，辐射全国各大核心城市',
  Sdw_zyitt7:'国内200多个数据中心及辐射节点，可覆盖全国大部分城市及地区',
  Sdw_zyitt8:'用户一经接入，即可实现全国大部分主要城市及地区的高效连接，将业务系统推向全国',
  Sdw_zyitt9:'全球网络节点分布',
  Sdw_zyitt10:'欧洲：荷兰（阿姆斯特丹），德国（法兰克福），美国，美西（西雅图），美西（洛杉矶），美东（达拉斯）',
  Sdw_zyitt11:'亚太地区：香港，台湾，印度，新加坡，柬埔寨，马来西亚，印度尼西亚',
  Sdw_zyitt12:'安全网络',
  Sdw_zyitt13:'实现分支边界安全隔离，终端安全，2-7层安全防护',
  Sdw_zyitt14:'实现在线行为审计，满足网络安全要求，实现多NFV按需授权部署',
  Sdw_zyitt15:'加速网络',
  Sdw_zyitt16:'提供更好的访问体验',
  Sdw_zyitt17:'显著降低带宽成本',
  Sdw_zyitt18:'应用程序的智能路由。不是策略路由',
  Sdw_zyitt19:'微网络',
  Sdw_zyitt20:'提供微分支网络的最佳性价比选择',
  Sdw_zyitt21:'一台设备解决了微分支的所有IT需求[4G、5G、WiFi]',
  Sdw_zyitt22:'即插即用，快速在线',
  Sdw_zyitt23:'云网络',
  Sdw_zyitt24:'提供公共云、混合云平台等云连接',
  Sdw_zyitt25:'平台间联网，云迁移',
  Sdw_zyitt26:'Global的云网结合',
  Sdw_zyitt27:'Global的云网结合是基于全球200多个pop节点做接入，与全球主流公有云互联所构建的网络资源池，为企业提供高稳定、高质量的公有云、数据中心及企业机构之间的高速专线服务，连接场景包括数据中心到公有云，公有云到公有云等，帮助企业快速上云，并解决异地数据传输、容备等多区域业务互联，及跨云业务访问',

}


// WEBPACK FOOTER //
// ./src/common/lang/zh.js